import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import "./kontakt.css";

emailjs.init({ publicKey: "KML-P95O0jZPSRfqn" });

export default function ContactSection() {
  const [kontakt, setKontakt] = useState({});

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetch("https://carboncro.hr/wp-json/wp/v2/pages?slug=kontakt")
      .then(res => res.json())
      .then(data => {
        if (data[0]) setKontakt(data[0].acf);
      })
      .catch(err => console.error("Greška pri dohvatu kontakt podataka:", err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const templateParams = {
      name,
      email,
      subject: "Kontakt poruka",
      details: message,
    };

    try {
      await emailjs.send("service_e1fywjb", "template_10gibk9", templateParams);
      alert("Poruka uspješno poslana!");
      setName("");
      setEmail("");
      setMessage("");
    } catch (error) {
      console.error("Greška:", error);
      alert("Greška pri slanju.");
    }
  };

  return (
    <section className="contact-section mt-5">
      <div className="contact-container mt-5">

        {/* LEFT */}
        <div className="contact-info">
          <h2>Kontaktiraj nas</h2>
          <p>
            Imaš pitanje ili želiš ponudu? Javi nam se i odgovaramo u najkraćem roku.
          </p>

          <div className="contact-adresa contact-item">
            📍 {kontakt.adresa || "Zagreb, Hrvatska"}
          </div>

          {/* KONTAKT 1 */}
          <div className="contact-person">
            <div className="contact-item contact-name">
              👤 {kontakt.ime_i_prezime || "—"}
            </div>
            <div className="contact-item">
              📞 <a className="contact-link" href={`tel:${kontakt.telefon}`}>
                {kontakt.telefon || "+385 00 000 000"}
              </a>
            </div>
            <div className="contact-item">
              ✉️ <a className="contact-link" href={`mailto:${kontakt.email}`}>
                {kontakt.email || "info@carboncro.hr"}
              </a>
            </div>
          </div>

          {/* KONTAKT 2 */}
          {kontakt.ime_i_prezime_2 && (
            <div className="contact-person">
              <div className="contact-item contact-name">
                👤 {kontakt.ime_i_prezime_2}
              </div>
              <div className="contact-item">
                📞 <a className="contact-link" href={`tel:${kontakt.telefon_2}`}>
                  {kontakt.telefon_2}
                </a>
              </div>
              <div className="contact-item">
                ✉️ <a className="contact-link" href={`mailto:${kontakt.email_2}`}>
                  {kontakt.email_2}
                </a>
              </div>
            </div>
          )}
        </div>

        {/* RIGHT */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Ime i prezime"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <textarea
            placeholder="Poruka..."
            rows="5"
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
          <button type="submit">Pošalji poruku</button>
        </form>

      </div>
    </section>
  );
}